import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WavesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"waves"}/>
}
